import { render, staticRenderFns } from "./CourseViewSectionList.vue?vue&type=template&id=4a591bc4&"
import script from "./CourseViewSectionList.vue?vue&type=script&lang=js&"
export * from "./CourseViewSectionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports